//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../Annotations/Annotations.StyleBuilder.js";
import "../Drawings/Drawings.SelectDraftingView.js";
import "../no/DisplayableObject.js";
import "../no/SelectObject.js";
let d=[[[0,"AftPerpendicular",1,0],[0,"Axis",1,0],[0,"Baseline",1,0],[0,"BulkHeads",1,0],[0,"Centerline",1,0],[0,"Decks",1,0],[0,"ForwardPerpendicular",1,0],[0,"HorizontalDistance",1,0],[0,"HorizontalPosition",1,0],[0,"InterTransverseFrames",1,0],[0,"LongitudinalBulkheads",1,0],[0,"LongitudinalYFrames",1,0],[0,"LongitudinalYInsertFrames",1,0],[0,"LongitudinalZFrames",1,0],[0,"LongitudinalZInsertFrames",1,0],[0,"MainLine",1,0],[0,"MainLineColor",1,0],[0,"MainLineFont",1,0],[0,"MainLineWidth",1,0],[0,"Midship",1,0],[1,"Origin",0,"Annotations.OriginBuilder",0],[0,"OriginType",1,0],[1,"Style",0,"Annotations.StyleBuilder",0],[0,"TransveralInsertArea",1,0],[0,"TransverseFrames",1,0],[0,"VerticalDistance",1,0],[0,"VerticalPosition",1,0],[1,"View",0,"Drawings.SelectDraftingView",0],[0,"Waterline",1,0]],[[[],"UpdateFromConceptModel",{},0,0],[[],"ReverseTics",{},0,0],[[],"CreateFrameBarObject",{},0,0],[[],"GetFramebar",{R_:{frameBar:"Annotations.BaseFrameBar"}},0,0],[[],"UpdateFrameBarFromStyle",{},0,0],[[],"ReverseAlongHullSide",{},0,0],[[],"DeleteFrameBarObject",{},0,0]],[]];
SPLM.Annotations.BaseFrameBarBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.BaseFrameBarBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.BaseFrameBarBuilder.AxisType = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z", "AlongHull" : "AlongHull"});

SPLM.Annotations.BaseFrameBarBuilder.OriginOption = Object.freeze({
    "SpecifyPosition" : "SpecifyPosition", "Distance" : "Distance"});

SPLM.Annotations.BaseFrameBarBuilder.HorizontalPositionType = Object.freeze({
    "Above" : "Above", "ShipCenter" : "ShipCenter", "ViewCenter" : "ViewCenter", "Below" : "Below"});

SPLM.Annotations.BaseFrameBarBuilder.VerticalPositionType = Object.freeze({
    "Left" : "Left", "ShipCenter" : "ShipCenter", "ViewCenter" : "ViewCenter", "Right" : "Right"});

export default SPLM;